import { z } from 'zod';
import {
  liveLocationSchema,
  progressUpdateSchema,
  type CreateProgressUpdateInput,
  type LiveLocation,
  type ProgressUpdate,
  type ShareLocationInput,
} from '@teentack/shared';
import { apiFetch, post } from '@/lib/api-client';

const progressListSchema = z.object({ items: z.array(progressUpdateSchema) });

export async function fetchProgress(assignmentId: string): Promise<ProgressUpdate[]> {
  const result = await apiFetch<unknown>(`/assignments/${assignmentId}/progress`);
  return progressListSchema.parse(result).items;
}

export async function addProgress(
  assignmentId: string,
  input: CreateProgressUpdateInput,
): Promise<ProgressUpdate> {
  return progressUpdateSchema.parse(
    await post<unknown>(`/assignments/${assignmentId}/progress`, input),
  );
}

export async function fetchLocation(assignmentId: string): Promise<LiveLocation> {
  return liveLocationSchema.parse(await apiFetch<unknown>(`/assignments/${assignmentId}/location`));
}

export async function shareLocation(
  assignmentId: string,
  input: ShareLocationInput,
): Promise<LiveLocation> {
  return liveLocationSchema.parse(
    await post<unknown>(`/assignments/${assignmentId}/location`, input),
  );
}

export async function stopSharingLocation(assignmentId: string): Promise<{ stopped: boolean }> {
  return apiFetch<{ stopped: boolean }>(`/assignments/${assignmentId}/location`, {
    method: 'DELETE',
  });
}
